import { code46Products } from "./code46Data";
import { products23 } from "./code23Data";
import { code55Products } from "./code55Data";

// Общий каталог для главной: все линейки в одном списке.
// line — по нему работают кнопки «CODE 46» / «CODE 23» / «CODE 30/55»
export const allCatalogProducts = [
  ...code46Products.map((p) => ({ ...p, line: "code46" })),
  ...products23.map((p) => ({ ...p, id: `c23-${p.id}`, line: "code23" })),
  ...code55Products.map((p) => ({ ...p, line: "code55" })),
];

export default allCatalogProducts;
